(() => {
  if(customElements.get('lk-strada-story'))return;
  class StradaStory extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();
      this.style.visibility='hidden';this.stylesReady=false;
      this.gallery=this.querySelector('.sp-story-images');
      this.pendants=[...this.querySelectorAll('[data-story-pendant]')];
      if(!this.gallery || !this.pendants.length)return;
      this.anchor=this.closest('.sp-room-settings');
      this.storySections=[...document.querySelectorAll('#MainContent .lk-blade-story, #MainContent .sp-story-section')];
      this.motion=matchMedia('(prefers-reduced-motion:reduce)');
      this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();});};
      document.querySelectorAll('link[rel="stylesheet"][href*="lk-strada-story.css"]').forEach(link=>link.addEventListener('load',this.schedule,{once:true,signal:this.abort.signal}));
      this.motion.addEventListener('change',this.schedule,{signal:this.abort.signal});
      window.addEventListener('scroll',()=>{if(this.visible && !this.motion.matches)this.schedule();},{passive:true,signal:this.abort.signal});
      window.addEventListener('resize',this.schedule,{passive:true,signal:this.abort.signal});
      this.resize=new ResizeObserver(this.schedule);this.resize.observe(this.gallery);
      if(this.anchor)this.resize.observe(this.anchor);
      this.storySections.forEach(section=>this.resize.observe(section));
      this.observer=new IntersectionObserver(entries=>{
        this.visible=entries.some(entry=>entry.isIntersecting);
        this.classList.toggle('is-visible',this.visible && !document.hidden);
        if(this.visible)this.schedule();
      });this.observer.observe(this.gallery);
      document.addEventListener('visibilitychange',()=>{this.classList.toggle('is-visible',this.visible && !document.hidden);if(!document.hidden)this.schedule();},{signal:this.abort.signal});
      this.update();
    }
    static placement(progress,height,headHeight){
      const p=Math.min(1,Math.max(0,progress)),scale=.88+.2*p;
      const start=24,end=Math.max(start,height-headHeight*scale-18);
      return {scale,drop:start+(end-start)*p,headHeight:headHeight*scale};
    }
    update(){
      if(!this.isConnected)return;
      if(!this.stylesReady){
        this.stylesReady=getComputedStyle(this).getPropertyValue('--sp-story-styled').trim()==='1';
        if(!this.stylesReady)return;
      }
      let rect=this.gallery.getBoundingClientRect();
      if(this.anchor && this.storySections.length){
        const top=this.anchor.getBoundingClientRect().bottom-1;
        const bottom=this.storySections[this.storySections.length-1].getBoundingClientRect().bottom;
        const height=Math.max(200,bottom-top);
        if(Math.abs((this.hangingHeight||0)-height)>.5){this.style.setProperty('--story-height',height.toFixed(3)+'px');this.hangingHeight=height;}
        rect={top,height};
      }
      const target=this.motion.matches ? .45 : Math.min(1,Math.max(0,(innerHeight-rect.top)/(innerHeight+rect.height)));
      const now=performance.now(),elapsed=this.lastFrameTime ? Math.min(32,now-this.lastFrameTime) : 1000/60;
      const follow=this.visible && !this.motion.matches && this.renderedProgress!==undefined;
      let progress=follow ? this.renderedProgress+(target-this.renderedProgress)*(1-Math.exp(-elapsed/170)) : target;
      const settling=follow && Math.abs(target-progress)>.00005;
      if(!settling)progress=target;
      this.renderedProgress=progress;
      this.lastFrameTime=settling ? now : 0;
      const placements=this.pendants.map(pendant=>{
        const head=pendant.querySelector('[data-story-head]');
        return {pendant,...StradaStory.placement(progress,rect.height,head.offsetHeight)};
      });
      for(const {pendant,scale,drop,headHeight} of placements){
        const angle=Math.atan(8.5/Math.max(1,drop+headHeight))*180/Math.PI;
        pendant.style.setProperty('--story-drop',drop.toFixed(3)+'px');
        pendant.style.setProperty('--story-wire',(drop+5).toFixed(3));
        pendant.style.setProperty('--story-scale',scale.toFixed(4));
        pendant.style.setProperty('--story-angle',angle.toFixed(4)+'deg');
      }
      this.style.removeProperty('visibility');
      if(settling)this.schedule();
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.resize?.disconnect();cancelAnimationFrame(this.frame);this.frame=0;this.lastFrameTime=0;this.renderedProgress=undefined;}
  }
  customElements.define('lk-strada-story',StradaStory);
})();

